import {
  Calendar,
  Egg,
  House,
  Microscope,
  Snowflake,
  Syringe,
} from "lucide-react";
import { ReactComponent as SpermIcon } from "./assets/images/nav/sperm.svg";

export type ToolType =
  | "dashboard"
  | "calc"
  | "hormone"
  | "implantation"
  | "oocyte"
  | "embryo"
  | "sperm";
export type NavigationItem = {
  path: ToolType;
  text: string;
  icon: JSX.Element;
  description?: string;
  fullText?: string;
  comingSoon?: boolean;
};
export const navigationItems: NavigationItem[] = [
  { path: "dashboard", text: "Dashboard", icon: <House />, description: "" },
  {
    path: "calc",
    text: "Egg Freezing Calculator",
    icon: <Snowflake />,
    description:
      "Estimate egg retrieval numbers and the likelihood of achieving a live birth.",
  },
  {
    path: "oocyte",
    text: "Oocyte Quality",
    fullText: "Oocyte Quality Assessment",
    icon: <Egg />,
    description: "Assess oocyte quality to improve fertility outcomes",
  },
  {
    path: "embryo",
    text: "Embryo Quality",
    fullText: "Embryo Quality Assessment",
    icon: <Microscope />,
    description: "Evaluate embryo development to boost pregnancy success. ",
  },
  {
    path: "hormone",
    text: "Hormonal Protocol",
    icon: <Syringe />,
    description:
      "Receive recommendations for hormonal protocols to maximize mature oocyte yield.",
    comingSoon: true,
  },
  {
    path: "implantation",
    text: "Implantation Window",
    icon: <Calendar />,
    description:
      "Pinpoint the optimal timing for embryo transfer to enhance implantation success.",
    comingSoon: true,
  },

  {
    path: "sperm",
    text: "Sperm Analysis",
    fullText: "Sperm Quality Analysis",
    icon: <SpermIcon />,
    description:
      "Analyze sperm quality to enhance fertility treatment outcomes.",
    comingSoon: true,
  },
];
export const reportPageWidth = 800;

export enum UserRole {
  SuperAdmin = 9,
  Admin = 1,
  Member = 2,
}

export type Clinic = {
  id: string;
  name: string;
  address?: string;
  created?: string;
  updated?: string;
};

export type ClinicListResponse = {
  clinics: Clinic[];
  next_page_token: string | null;
};

export enum EthnicityType {
  AmericanIndian = 1,
  Asian = 2,
  Black = 3,
  Hispanic = 4,
  PacificIslander = 5,
  White = 6,
  Other = -1,
}

export enum InfertilityCondition {
  Pcos = 1,
  Endometriosis = 2,
  Thyroid = 3,
  Autoimmune = 4,
  Diabetes = 5,
  Hypertension = 6,
  Other = -1,
}

export const measuringSystems = [ "imperial", "metric" ] as const;
export type MeasuringSystem = typeof measuringSystems[number];

export const scoretoText = (score: number, texts: string[]) => {
  if (score <= 20) return texts[0];
  if (score <= 35) return texts[1];
  if (score <= 60) return texts[2];
  return texts[3];
};
